{
  "Untitled event": "Evento sem título",
  "Under a minute": "Menos de um minuto",
  "{minutes} min": "{minutes} min",
  "{hours} h {minutes} min": "{hours} h {minutes} min",
  "{hours} h": "{hours} h",
  "Under 1 MB": "Menos de 1 MB",
  "{count} part": {
    "one": "{count} parte",
    "other": "{count} partes"
  },
  "{count} recording": {
    "one": "{count} gravação",
    "other": "{count} gravações"
  },
  "data file|Event details": "Detalhes dos eventos",
  "Every event's title, date, place, link and settings": "Título, data, local, link e configurações de cada evento",
  "Guests and registrations": "Convidados e inscrições",
  "Names, emails, how each guest joined and what they watched": "Nomes, e-mails, como cada convidado entrou e o que assistiu",
  "Guestbook messages": "Mensagens do livro de visitas",
  "Every message with its event, name and time": "Cada mensagem com o evento, o nome e o horário",
  "Viewer counts": "Número de espectadores",
  "Live and replay viewers for each recording": "Espectadores ao vivo e da gravação de cada vídeo",
  "Sales and donations": "Vendas e doações",
  "Tickets, paid downloads and donations, with amounts and dates": "Ingressos, downloads pagos e doações, com valores e datas",
  "This recording belongs to another account.": "Esta gravação pertence a outra conta.",
  "We couldn't find this recording. It may have been deleted.": "Não encontramos esta gravação. Ela pode ter sido excluída.",
  "Downloads are temporarily unavailable. Please try again in a few minutes.": "Os downloads estão temporariamente indisponíveis. Tente novamente em alguns minutos.",
  "Could not reach EventLive. Check your internet connection and try again.": "Não foi possível conectar ao EventLive. Verifique sua conexão com a internet e tente novamente.",
  "Ready to download": "Pronta para baixar",
  "{count} recording is being prepared": {
    "one": "{count} gravação está sendo preparada",
    "other": "{count} gravações estão sendo preparadas"
  },
  "Download this one when one of them is ready.": "Baixe esta quando uma delas estiver pronta.",
  "Could not load your recordings.": "Não foi possível carregar suas gravações.",
  "Couldn't download the file": "Não foi possível baixar o arquivo",
  "Still preparing. Long recordings take a while; you can leave this page and come back.": "Ainda em preparação. Gravações longas demoram um pouco; você pode sair desta página e voltar depois.",
  "Joining {parts} parts into one MP4. This usually takes a few minutes.": "Juntando {parts} partes em um único MP4. Isso costuma levar alguns minutos.",
  "Preparing the MP4. This usually takes a few minutes.": "Preparando o MP4. Isso costuma levar alguns minutos.",
  "This is taking much longer than usual. Try again, or contact support.": "Está demorando muito mais do que o normal. Tente novamente ou fale com o suporte.",
  "Couldn't prepare the download. Try again.": "Não foi possível preparar o download. Tente novamente.",
  "In the Secure Archive, so it can't be downloaded. Restore it to download it again, or delete it.": "No Arquivo Seguro, por isso não pode ser baixada. Restaure-a para baixá-la de novo ou exclua-a.",
  "In the Secure Archive, so it can't be downloaded. You can delete it.": "No Arquivo Seguro, por isso não pode ser baixada. Você pode excluí-la.",
  "Restore {title}": "Restaurar {title}",
  "Delete {title}": "Excluir {title}",
  "Download": "Baixar",
  "Preparing…": "Preparando…",
  "Preparing {title}": "Preparando {title}",
  "Try again: {title}": "Tentar novamente: {title}",
  "Download {title}": "Baixar {title}",
  "Guestbook PDF · {count} message": {
    "one": "PDF do livro de visitas · {count} mensagem",
    "other": "PDF do livro de visitas · {count} mensagens"
  },
  "Download the guestbook of {title} as a PDF": "Baixar o livro de visitas de {title} em PDF",
  "Download {title} (CSV)": "Baixar {title} (CSV)",
  "Deleted": "Excluído",
  "Couldn't delete it": "Não foi possível excluir",
  "Delete “{title}”?": "Excluir “{title}”?",
  "The event, its recording, guest list and guestbook are deleted for good. This can't be undone.": "O evento, a gravação, a lista de convidados e o livro de visitas serão excluídos para sempre. Não é possível desfazer.",
  "Delete event": "Excluir evento",
  "Loading your recordings…": "Carregando suas gravações…",
  "one MP4 file each": "um arquivo MP4 por gravação",
  "loading more…": "carregando mais…",
  "Download everything": "Baixar tudo",
  "Your recordings are yours. Download any of them, any time, free.": "Suas gravações são suas. Baixe qualquer uma delas, quando quiser, de graça.",
  "Give a family or a couple their video, or keep your own archive.": "Entregue o vídeo a uma família ou a um casal, ou guarde seu próprio arquivo.",
  "Download everything is for business accounts. To download a video, open its event and choose Download & View Stats.": "Baixar tudo é para contas empresariais. Para baixar um vídeo, abra o evento e escolha Baixar e ver estatísticas.",
  "Recordings": "Gravações",
  "Couldn't load your recordings": "Não foi possível carregar suas gravações",
  "No recordings yet": "Ainda não há gravações",
  "When you stream an event or upload a video, it shows up here, ready to download.": "Quando você transmite um evento ou envia um vídeo, ele aparece aqui, pronto para baixar.",
  "Search for a recording": "Pesquisar uma gravação",
  "Search recordings by title, place or date": "Pesquise gravações por título, local ou data",
  "Clear search": "Limpar pesquisa",
  "No recordings match “{query}”.": "Nenhuma gravação corresponde a “{query}”.",
  "Show {count} more": "Mostrar mais {count}",
  "{count} recording found.": {
    "one": "{count} gravação encontrada.",
    "other": "{count} gravações encontradas."
  },
  "Each MP4 joins every live session and upload in order, in the best quality we keep.": "Cada MP4 junta em ordem todas as transmissões ao vivo e os vídeos enviados, na melhor qualidade que guardamos.",
  "Long recordings are big files, so use a fast connection.": "Gravações longas são arquivos grandes, então use uma conexão rápida.",
  "It opens in your browser to save. Long recordings are big files: a computer on Wi-Fi is quickest.": "O arquivo abre no seu navegador para você salvar. Gravações longas são arquivos grandes: um computador no Wi-Fi é o mais rápido.",
  "Your data": "Seus dados",
  "Spreadsheets for Excel, Numbers or Google Sheets, covering every event in your account": "Planilhas para Excel, Numbers ou Google Sheets com todos os eventos da sua conta",
  "One page with your events that anyone with the link can watch, and your ticketed events, newest first.": "Uma página com os seus eventos que qualquer pessoa com o link pode assistir e os seus eventos com ingresso, dos mais recentes aos mais antigos.",
  "Your Video Wall link": "Link do seu Mural de vídeos",
  "Video Wall link": "Link do Mural de vídeos",
  "Copy Video Wall link": "Copiar link do Mural de vídeos",
  "Open Video Wall": "Abrir Mural de vídeos",
  "Embed on your website": "Embed no seu site",
  "Paste the code into your website's HTML or embed block.": "Cole o código no HTML do seu site ou em um bloco de incorporação.",
  "Code type": "Tipo de código",
  "Script (recommended)": "Script (recomendado)",
  "The wall grows to fit all your events instead of scrolling inside a box.": "O mural cresce para mostrar todos os seus eventos, em vez de rolar dentro de uma caixa.",
  "Simple iframe (no script)": "Iframe simples (sem script)",
  "For site builders that remove scripts. The wall scrolls inside the space your page gives it.": "Para criadores de sites que removem scripts. O mural rola dentro do espaço que a sua página reserva para ele.",
  "Copy embed code": "Copiar código Embed",
  "Embed code copied": "Código Embed copiado",
  "Paste it into your website's HTML.": "Cole-o no HTML do seu site."
}
